<template>
    <div class="wrapper-page">
        <div class="m-t-30 card card-body">
            <div class="text-center">
                <h4 class="text-uppercase font-bold m-b-0">{{ $t("NotFound.pageNotFound") }}</h4>
            </div>
            <div class="p-2 text-center ex-page-content">
                <img width="300" alt="404" :src="notFoundSVG"/>
                <p class="text-muted font-13 m-t-20 mb-2">{{ $t("NotFound.lookLikeYouTookAWrongPath") }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 text-center">
                <a href="#" @click.prevent="$router.go(-1)" class="text-primary m-l-5">
                    <span class="text-muted">{{ $t("NotFound.backTo") }}</span>
                    <b> {{ $t("NotFound.thePreviousPage") }}</b>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import notFoundSVG from "../../../assets/svg/page_not_found.svg";

export default {
    name: "NotFound",
    data() {
        return {
            notFoundSVG,
        };
    },
};
</script>

<style scoped>

</style>